import { ObservedAttributes } from "@self/utils";
import { bound, CustomElement, customElement } from "../CustomElement";

@customElement("gct-billing-address-checkbox")
export class BillingCheckbox extends CustomElement {

	static get observedAttributes() {
		return ["checked", "disabled", "target"] as const;
	}

	input: HTMLInputElement;

	get checked() { return this.hasAttribute("checked"); }

	set checked(value: boolean) {
		if (value) {
			this.setAttribute("checked", "");
		} else {
			this.removeAttribute("checked")
		}
	}

	get disabled() { return this.hasAttribute("disabled"); }

	set disabled(value: boolean) {
		if (value) {
			this.setAttribute("disabled", "");
		} else {
			this.removeAttribute("disabled");
		}
	}

	get target() { return this.getAttribute("target"); }

	set target(value: string | null) {
		if (value !== null) {
			this.setAttribute("target", value);
		} else {
			this.removeAttribute("target");
		}
	}

	constructor() {
		const input = <input type="checkbox" /> as HTMLInputElement;

		super(
			<label className="gct-custom-checkbox">
				{input}
				<span>Billing address same as delivery address</span>
			</label>
		);

		input.checked = this.hasAttribute("checked");
		input.disabled = this.hasAttribute("disabled");

		this.input = input;
	}

	connectedCallback() {
		window.addEventListener("DOMContentLoaded", this.externalDomInit, { once: true });
		this.externalDomInit();

		this.input.addEventListener("change", this.onChange);
	}

	disconnectedCallback() {
		this.input.removeEventListener("change", this.onChange);
	}

	@bound
	externalDomInit() {
		setTargetVisibility(this.target, !this.checked);
	}

	attributeChangedCallback(name: ObservedAttributes<typeof BillingCheckbox>, oldValue: string | null, newValue: string | null) {
		switch (name) {
			case "checked": {
				const checked = newValue !== null;
				this.input.checked = checked;
				setTargetVisibility(this.target, !this.checked);
				break;
			}
			case "disabled":
				this.input.disabled = newValue !== null;
				break;
			case "target": {
				setTargetVisibility(oldValue, true);
				setTargetVisibility(newValue, !this.checked);
			}
		}
	}

	@bound
	onChange() {
		this.checked = this.input.checked;
	}
}

function setTargetVisibility(target: string | null, visible: boolean): void {
	if (target === null) return;

	const targetElement = document.querySelector<HTMLElement>(target);
	if (targetElement !== null) {
		targetElement.style.display = visible ? "" : "none";
	}
}
